export default __webpack_public_path__ + "static/media/Log_Out.44504d6e.svg";